import type { AppKind } from "common/components/SerializedApp";
import { isEmptyOrUndefined } from "common/Support";
import { getLocationSettings } from "../../lib/location";
import * as routes from "../../routes";

export function localhostURL(appID: string): string | undefined {
    const { hostname } = window.location;
    if (hostname !== "localhost") return undefined;
    return `${window.location.origin}${routes.play(appID)}`;
}

function playLinkForLocation(appID: string) {
    return `${getLocationSettings().urlPrefix}play/${appID}`;
}

function isValidShortNameForLocation(appKind: AppKind, shortName: string): boolean {
    return shortName.endsWith(getLocationSettings(appKind).shortnameSuffix);
}

export function urlForApp(
    appID: string,
    appKind: AppKind,
    app: { readonly shortName: string | undefined; readonly customDomain: string | undefined } | undefined
): string {
    const maybeURL = localhostURL(appID);
    if (maybeURL !== undefined) {
        return maybeURL;
    }

    if (app !== undefined) {
        if (!isEmptyOrUndefined(app.customDomain)) {
            return "https://" + app.customDomain;
        }
        if (!isEmptyOrUndefined(app.shortName) && isValidShortNameForLocation(appKind, app.shortName)) {
            return "https://" + app.shortName;
        }
    }

    return playLinkForLocation(appID);
}
